declare namespace $ {

	export class $mol_icon_basket extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=basket.view.tree.d.ts.map